import { BillingKeys, BillingState } from '../../state/reducers/billingReducer'

export const getSubscriptionToCancel = (state: { billing: BillingState }) =>
  state.billing[BillingKeys.subscriptionToCancel]

export const getSubscriptions = (state: { billing: BillingState }) =>
  state.billing[BillingKeys.subscriptions]
